/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 日時設定セレクト
 * @export
 * @enum {string}
 */

export const DateTimeEnum = {
    Today: 'today',
    ThisWeek: 'this_week',
    ThisMonth: 'this_month'
} as const;

export type DateTimeEnum = typeof DateTimeEnum[keyof typeof DateTimeEnum];



